import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  oneRow: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical'
  }
}))
